<template>
  <div style="padding-top:30px;background:#ffffff;">
    <el-row :gutter="20">
      <el-col :span="10">
        <div class="grid-content bg-purple content left-content">
          <div style="overflow:hidden;">
            <div>
              <span class="title">字典管理</span>
              <div style="display:inline-block;float:right">
                <div
                  class="search-box"
                  style="display:inline-block; width:200px;padding-bottom:20px;"
                >

                  <el-input
                    v-model="searchContent"
                    placeholder="请输入字典编号或字典名称"
                    clearable
                  />
                </div>
                <div
                  class="search-box"
                  style="display:inline-block;padding-left:10px;"
                >
                  <el-button
                    type="primary"
                    @click="search"
                  >搜索</el-button>
                </div>
                <el-button
                  type="primary"
                  style="margin-left:8px"
                  @click="add"
                >新增字典</el-button>
              </div>
            </div>
          </div>

          <el-table
            :key="tableKey"
            ref="singleTable"
            highlight-current-row
            v-loading="listLoading"
            :data="tableData"
            stripe
            tooltip-effect="dark"
            style="width: 100%"
            @cell-mouse-enter="operateShow"
            @cell-mouse-leave="operateClose"
            @current-change="handleCurrentClick"
          >
            <el-table-column
              :show-overflow-tooltip="true"
              label="字典编号"
              min-width="100px"
            >
              <template slot-scope="scope">{{ emptyDeal(scope.row.id) }}</template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              label="字典名称"
              min-width="100px"
            >
              <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              label="Key值"
              min-width="100px"
            >
              <template slot-scope="scope">{{ emptyDeal(scope.row.dicKey) }}</template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              label="字典类型"
              min-width="100px"
            >
              <template slot-scope="scope">{{ scope.row.type=="1"?"系统":"普通" }}</template>
            </el-table-column>
            <el-table-column align="right">
              <template
                slot-scope="scope"
                class="icon"
              >
                <div
                  class="icon"
                  style="text-align:center;"
                >
                  <i
                    class="el-icon-change"
                    @click="editRole(scope.row)"
                  />
                  <i
                    style="margin-left:16px;"
                    v-if="scope.row.type==2"
                    class="el-icon-dele"
                    @click="delet(scope.row.id)"
                  />
                </div>

              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="mt10">
            <el-pagination
              :current-page="pageInfo.currentPage"
              :page-sizes="pageInfo.pageSizeList"
              :page-size="pageInfo.limit"
              layout="total, prev, pager, next, jumper"
              :total="pageInfo.allCount"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <div class="grid-content bg-purple content right-content">
          <template>
            <div v-if="true">
              <DictInfo ref="dictinfoson" />
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
    <template>
      <div v-if="isShowEdit">
        <EditDict
          :edit-data="currentData"
          :isedit="isedit"
          @handleclose="closeDialog"
          @refresh="getRoleList"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { statusTrans, emptyTrans, sortDataList } from '@/api/dataTrans.js'
import { dictList, deleteDic, systemDetail, getSystem } from '@/api/system'
import EditDict from './editdict'
import DictInfo from './dictInfo'
export default {
  components: { EditDict, DictInfo },
  data() {
    return {
      dictId: null,
      currentRow: null,
      listLoading: true,
      currentData: {},
      isShowEdit: false,
      isedit: false,
      searchContent: '',
      tableKey: 0,
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      tableData: [],
      appId:""
    }
  },
  computed: {
    isShowDictInfo() {
      let result = false
      if (this.dictId) {
        result = true
      }
      return result
    }
  },
  mounted() {
    this.getRoleList()
  },
  methods: {
    setCurrent(row) {
      this.dictId = row.id
      this.$refs.singleTable.setCurrentRow(row)
      this.$refs.dictinfoson.getRoleList(this.dictId)
    },
    handleCurrentClick(row) {
      this.dictId = row.id
      this.$refs.dictinfoson.getRoleList(this.dictId)
      // this.currentRow = row;
    },
    add() {
      this.currentData = {}
      this.isShowEdit = true
      this.isedit = false
    },
    editRole(data) {
      this.currentData = data
      this.isShowEdit = true
      this.isedit = true
    },
    closeDialog() {
      this.isShowEdit = false
      this.isShowAdd = false
      this.isedit = false
    },
    search() {
      this.getRoleList()
    },
    getRoleList() {
      dictList({
        parentId: 0,
        searchKey: this.searchContent,
        page:this.pageInfo.currentPage,
        size:this.pageInfo.limit
      }).then(res => {
        if (res && res.code == 0) {
          this.tableData = res.data.items
          this.setCurrent(this.tableData[0])
          this.pageInfo.allCount = res.data.total
        }
      })
      this.listLoading = false
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.getRoleList()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getRoleList()
    },
    delet(data) {
      const _this = this
      _this.$confirm('您确认删除该字典及字典项吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteDic({
          ids: data
        }).then(res => {
          _this.$message.success('删除成功')
          _this.getRoleList()
        })
      }).catch(() => { })
    },
    // 显示操作按钮
    operateShow(row, column, cell, event) {
      event.path[1].cells[4].children[0].children[0].style.display = 'block'
    },
    operateClose() {
      event.path[1].cells[4].children[0].children[0].style.display = 'none'
    },
    emptyDeal(_val) {
      return emptyTrans(_val)
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  min-height calc(100vh - 218px)
  padding 0 24px
.right-content
  border-left 1px solid #e8e8e8
[class^='el-icon-']:hover
  color #ffa940
.icon
  display none
.el-icon-edit
  padding 0px 5px
.el-icon-delete
  padding 0px 5px
.mt10
  margin-top 24px !important
  float right
.title
  text-align left
  font-size 14px
  color rgba(0, 0, 0, 0.85)
</style>
